import React from 'react';
import PropertyAssignmentBody from './PropertyAssignmentBody';
import Grid from '@mui/material/Grid';
import { ThemeProvider, createTheme } from '@mui/material/styles'
import PropertyAssignmentDataGrid from './PropertyAssignmentDataGrid';
import { InspectionContents } from './../../css/CSS'

export default function PropertyAssignmentFrame() {

    const inspectionTheme = createTheme({
        palette: {
            background: {
                default: '#f8f7f6'
            }
        },
        typography: {
            fontFamily: [
                '"Noto Sans JP"',
                'Roboto',
                '"Helvetica"',
                'Arial',
                'sans-serif',
            ].join(','),
        }
    })


    return (
            <ThemeProvider theme={inspectionTheme}>
                <InspectionContents sx={{ pb: 2, pt: 2, }} maxWidth="xl">
                    < Grid sx={{ height: 64 }} />
                    <Grid container columns={12} spacing={0} sx={{ pt: 2 }} maxWidth="xl" >
                        <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <PropertyAssignmentBody />
                        </Grid>
                    </Grid>
                </InspectionContents>
            </ThemeProvider>
    );
}